<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Total De {{ItemLabel}} {{TitleTypeFIN}} en {{CurrentLibraryName}}</h1>
</div>


<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">

  <!---================= CONTAINER SELECT TYPE FIN =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-chart-simple"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Tipo de reporte</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select [(ngModel)]="ValueTypeFIN" (change)="ChangeTypeFIN()" class="Custom-Form" [searchable]="false"
            [items]="OptionsTypeFIN" bindLabel="item" autofocus [clearable]="false" bindValue="value">
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>

      </div>

    </div>
  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Total De {{ItemLabel}} {{TitleTypeFIN}} en {{CurrentLibraryName}}</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER GENERATE REPORT =================--->
        <div class="Container-Buttons">
          <div class="Generate-Report-Level">
            {{Data_Report_List.length}}
          </div>
        </div>
      </div>

    </div>

  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <div class="Container-Buttons">

          <button (click)="ReloadPage()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </button>

        </div>
      </div>

    </div>

  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-cloud-arrow-down"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Descargas</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER DOWNLOAD FILE =================--->
        <div class="Container-Buttons">

          <button (click)="DownloadReportXLSX()" class="Btn-Option XLSX button-square">
            <span class="Tool-Tip">Descargar Excel</span>
            <i class="fa-regular fa-file-excel"></i>
          </button>

          <button (click)="DownloadReportPDF()" class="Btn-Option PDF button-square">
            <span class="Tool-Tip">Descargar pdf</span>
            <i class="fa-regular fa-file-pdf"></i>
          </button>

        </div>
      </div>

    </div>

  </div>

</div>



<div class="container-global-components ConRL">

  <div *ngIf="Data_Report_List.length > 0;else Not_FIN_RL" class="Table-Lib Table-container-Global">

    <p-table #dt [value]="Data_Report_List" [(selection)]="SelectedData_Report_List" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','Code','Purpose','Revision_No','Approver1_Name','Approver2_Name','Approver3_Name','Approver4_Name']">

      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR CCP SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_RList" type="text"
                (input)="dt.filterGlobal(Filter_RList, 'contains')" placeholder="Buscar en reporte listado" />
            </div>
          </div>
          <div class="right-CT">

          </div>
        </div>

      </ng-template>

      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Header of HeadersRL">

            <ng-container *ngIf="Header.Key_Header==='UBICA'">
              <th pSortableColumn="Path" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Path"></p-sortIcon>
                    <p-columnFilter type="text" field="Path" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAMFI'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'CODEF'">
              <th class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DESCR'">
              <th pSortableColumn="Purpose" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Purpose"></p-sortIcon>
                    <p-columnFilter type="text" field="Purpose" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOREV'">
              <th pSortableColumn="Revision_No" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter field="F_Revision_No" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Revision_No"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='CONTR'">
              <th pSortableColumn="Contributor_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Contributor_Name"></p-sortIcon>
                    <p-columnFilter field="F_Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DACRE'">
              <th pSortableColumn="Date_Created" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Created"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAEXP'">
              <th pSortableColumn="Date_Expiration" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_End"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_End" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR1' && Header.Visible">
              <th pSortableColumn="Approver1_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver1_Name"></p-sortIcon>
                    <p-columnFilter field="F_Approver1_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver1_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR2' && Header.Visible">
              <th pSortableColumn="Approver2_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver2_Name"></p-sortIcon>
                    <p-columnFilter field="F_Approver2_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver2_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR3' && Header.Visible">
              <th pSortableColumn="Approver3_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver3_Name"></p-sortIcon>
                    <p-columnFilter field="F_Approver3_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver3_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR4' && Header.Visible">
              <th pSortableColumn="Approver4_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver4_Name"></p-sortIcon>
                    <p-columnFilter field="F_Approver4_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">{{Header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver4_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USASS' && ValueTypeFIN===2">
              <th pSortableColumn="Approver_Assigned" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Assigned"></p-sortIcon>
                    <p-columnFilter field="F_Approver_Assigned" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Finance Director or CFO</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Assigned"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USREJ' && ValueTypeFIN===3">
              <th pSortableColumn="Approver_Rejected" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Rejected"></p-sortIcon>
                    <p-columnFilter field="F_Approver_Rejected" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Finance Director or CFO</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Rejected"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REASO' && ValueTypeFIN===3">
              <th pSortableColumn="Reason_Rejected" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Reason_Rejected"></p-sortIcon>
                    <p-columnFilter type="text" field="Reason_Rejected" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='STATU'">
              <th pSortableColumn="Status" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="F_Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" optionLabel="Value" [options]="Filter_Global_Check.Status"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option.Value">
                                    <div *ngSwitchCase='1'>Aprobado</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazado</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>


          </ng-container>
          <th><i class="fa fa-question-circle"></i></th>
        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-Data_Report_List>

        <tr>

          <ng-container *ngFor="let Header of HeadersRL">
            <ng-container *ngIf="Header.Key_Header==='UBICA'">
              <td>
                <div (click)="SeeFINLibrary(Data_Report_List.Path)">{{Clean_Route(Data_Report_List.Path)}}</div>
              </td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAMFI'">
              <td>{{Data_Report_List.Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'CODEF'">
              <td>
                <div class="Description">

                  <div class="Text-Description">
                    {{Cut_Code(Data_Report_List.Code)}}
                  </div>

                  <button (click)="See_Code(Data_Report_List.Code)" *ngIf="Data_Report_List.Code.length > 15"
                    class="Btn-Description">
                    <i class="fa-regular fa-file-lines"></i>
                    <div class="Tool-Tip T-Description">Ver Código</div>
                  </button>

                </div>
              </td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DESCR'">
              <td>
                <div class="Description">

                  <div class="Text-Description">
                    {{Cut_Purpose(Data_Report_List.Purpose)}}
                  </div>

                  <button (click)="See_Purpose(Data_Report_List.Purpose)" *ngIf="Data_Report_List.Purpose.length > 32"
                    class="Btn-Description">
                    <i class="fa-regular fa-file-lines"></i>
                    <div class="Tool-Tip T-Description">Ver objetivo</div>
                  </button>

                </div>
              </td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOREV'">
              <td>{{Data_Report_List.Revision_No}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='CONTR'">
              <td>{{Data_Report_List.Contributor_Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DACRE'">
              <td>{{Date_Format(Data_Report_List.Date_Created)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAEXP'">
              <td>{{DateFormat_Approved(Data_Report_List.Date_End,Data_Report_List.Status)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR1' && Header.Visible">
              <td>{{Get_Name_Approver(Data_Report_List.Approver1_Name)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR2' && Header.Visible">
              <td>{{Get_Name_Approver(Data_Report_List.Approver2_Name)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR3' && Header.Visible">
              <td>{{Get_Name_Approver(Data_Report_List.Approver3_Name)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APPR4' && Header.Visible">
              <td>{{Get_Name_Approver(Data_Report_List.Approver4_Name)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USASS' && ValueTypeFIN===2">
              <td>{{Data_Report_List.Approver_Assigned}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USREJ' && ValueTypeFIN===3">
              <td>{{Data_Report_List.Approver_Rejected}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REASO' && ValueTypeFIN===3">
              <td>
                <div class="Description">

                  <div class="Text-Description">
                    {{Cut_Reason(Data_Report_List.Reason_Rejected)}}
                  </div>

                  <button (click)="See_Reason(Data_Report_List.Reason_Rejected)"
                    *ngIf="Data_Report_List.Reason_Rejected!==null && Data_Report_List.Reason_Rejected.length > 32"
                    class="Btn-Description">
                    <i class="fa-regular fa-file-lines"></i>
                    <div class="Tool-Tip T-Description">Ver objetivo</div>
                  </button>

                </div>
              </td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='STATU'">
              <td>{{Status_string(Data_Report_List.Status)}}</td>
            </ng-container>

          </ng-container>

          <td>
            <div class="Container-Status">
              <div class="Status-RLH {{Status_Type(Data_Report_List.Status)}}">
              </div>
            </div>
          </td>

        </tr>

      </ng-template>

    </p-table>

  </div>

  <ng-template #Not_FIN_RL>
    <div *ngIf="Load_Page" class="Not-Report-RL">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Not-Report.png" alt="">
      </div>
      <div class="Text-Not-Report-RL">
        No existen {{ItemLabel}} {{TitleTypeFIN}} en este directorio.
      </div>
    </div>
  </ng-template>


</div>



<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR REPORT PDF OR XLSX =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando reporte ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>
